export const toastKey = {
  default: "default",
  msal: "msal",
};
